// @avantia common-code
import { addToWindowRef, ensureDefined, getFromWindowRef, voidFunction } from '@avantia/client-and-server-utilities';
import { questionIdConstants } from '@avantia/questionset-model';
import jQuery from 'jquery';
import { HpClientDebugFlags } from '../clientDebugFlags';
import { logInfo } from '../clientLogging';

const questionIds = questionIdConstants;
const showClass = 'hp-ie-show';
const hideClass = 'hp-ie-hide';
const summaryClass = 'hp-ie-summary';
const focusFixClass = 'hp-ie-focus-fix';
const isIE = isInternetExplorer();

export const runIeHacks = !isIE
  ? voidFunction
  : () => {
      setInterval(() => {
        const summaries = $('details > summary');
        for (let i = 0; i < summaries.length; i++) {
          processSummary(summaries[i], i);
        }

        setImproperFocusFix();
      }, 250);
    };

function processSummary(summary: HTMLElement, index: number): void {
  const $ = jQuery;
  const $summary = $(summary);
  if ($summary.hasClass(summaryClass)) {
    return;
  }

  const parent = summary.parentNode as HTMLElement;
  $summary.addClass(`${summaryClass} ${hideClass}`);

  if (index === 0) {
    const prevSibling = summary.previousElementSibling;
    if (prevSibling && prevSibling.nodeName === 'BR') {
      parent.removeChild(prevSibling);
    }
  }

  const siblings: ChildNode[] = [];
  let sibling: ChildNode | null = summary;
  while (sibling) {
    if (sibling) {
      if (sibling.nodeName === '#text') {
        const span = document.createElement('span');
        parent.insertBefore(span, sibling);
        parent.removeChild(sibling);
        span.appendChild(sibling);
        sibling = span;
      }

      $(sibling).addClass(hideClass);
      siblings.push(sibling);
    }

    sibling = sibling.nextSibling;
  }

  $summary.on('click', () => {
    siblings.forEach((s) => {
      const $s = $(s);
      if ($s.hasClass(showClass)) {
        $s.removeClass(showClass).addClass(hideClass);
      } else {
        $s.removeClass(hideClass).addClass(showClass);
      }
    });
  });
}

// When transitioning between sections, IE sometimes sets the ':focus' selector
// on elements but forgets to remove it when the mouse navigates away.
// So far it only happens for one question (that we know of).
function setImproperFocusFix() {
  [questionIds.propertyType].forEach((id) => setImproperFocusFixForId(id, false));
}

function setImproperFocusFixForId(id: string, ignoreClass: boolean): void {
  const question = document.getElementById('QP' + id);
  if (!question) {
    return;
  }

  const $question = $(question);
  if ($question.is(':visible') && (ignoreClass === true || !$question.hasClass(focusFixClass))) {
    setTimeout(() => {
      const { parentElement: parent } = question;
      if (!parent) {
        return;
      }

      const children = [...Array.from(parent.children)] as HTMLElement[];
      const index = children.findIndex((c) => c === question);
      const nextSibling = index < 0 ? undefined : children[index + 1];
      const removedElement = parent.removeChild(question);

      let insertedElement: HTMLElement | undefined;
      if (nextSibling) {
        insertedElement = parent.insertBefore(removedElement, nextSibling) as HTMLElement;
      } else {
        insertedElement = parent.appendChild(removedElement);
      }

      if (insertedElement) {
        $(insertedElement).addClass(focusFixClass);
        logInfo(`Executed IE incorrect focus fix for '${id}'.`, HpClientDebugFlags.None);
      }
    }, 50);
  }
}

const hpSetImproperFocusFixForId: HpSetImproperFocusFixForIdFunction = (id, ignoreClass) => {
  setImproperFocusFixForId(ensureDefined(id, 'id'), ensureDefined(ignoreClass, 'ignoreClass'));
};

addToWindowRef({ hpSetImproperFocusFixForId }); // for testing

type HpSetImproperFocusFixForIdFunction = (id: string, ignoreClass: boolean) => void;

export function isInternetExplorer(): boolean {
  interface WindowDetail {
    navigator: Navigator;
  }

  const { navigator } = getFromWindowRef<WindowDetail>(['navigator']) || {};
  const isIe = !!navigator && navigator.userAgent.indexOf('Trident') >= 0;
  return isIe;
}
